exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Anton|Aldrich);", ""]);

// module
exports.push([module.id, "a:link, a:hover, a:visited, a:active {\r\n    text-decoration: none;\r\n}\r\n\r\n#logo-container {\r\n    display: block;\r\n    position: fixed;\r\n    background-color: #212121;\r\n    height: 50px;\r\n    top: 20px;\r\n    left: 70px;\r\n    z-index: 9999;\r\n}\r\n\r\n#logo {\r\n    font-family: 'Aldrich', sans-serif;\r\n    color: #FFF;\r\n    font-size: 25px;\r\n    margin: 12.5px 20px;\r\n    padding: 0px;\r\n} \r\n\r\n#logo span {\r\n    color: #a53232;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/claudio/Projects/thebatclaudio.github.io/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main